<template>
  <div id="app">
    <div class="wechat-kouling">
      <div>
        <div class="leftCircle"></div>
        <div class="rightCircle"></div>
        <img class="title" src="~assets/images/kouling-title.svg" />
        <div class="kouling-bg">
          <h2>{{ getVal.koulingName }}</h2>
        </div>
        <img class="copy" src="~assets/images/kouling-copy.svg" />
        <img class="reward" src="~assets/images/kouling-reward.svg" />
        <div class="rewardBox">
          <div class="goldText">
            <img src="~assets/images/kouling-gold.svg" />
            <p>{{parseInt(JSON.parse(getVal.prize)[0].from)}}~{{parseInt(JSON.parse(getVal.prize)[0].to)}}金币</p>
          </div>
          <div class="redText">
            <img src="~assets/images/kouling-red.svg" />
            <p>{{(JSON.parse(getVal.prize)[1].from / 10).toFixed(2)}}~{{(JSON.parse(getVal.prize)[1].to / 10).toFixed(2)}}现金</p>
          </div>
        </div>
        <p id="text1">填写时间截止到{{getVal.endTime | timestampToDate}}</p>
        <button id="downloadButton" ref="downloadButton"></button>
        <p id="text2">每日口令11:00更新，数量有限，先到先得！</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      listData: []
    };
  },
  filters: {
    timestampToDate: function(val) {
      if (!val) {
        return "无";
      }
      var date = new Date(Number(val));
      var y = date.getFullYear();
      var M = date.getMonth() + 1;
      var d = date.getDate();
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();
      M = M < 10 ? "0" + M : M;
      d = d < 10 ? "0" + d : d;
      h = h < 10 ? "0" + h : h;
      m = m < 10 ? "0" + m : m;
      s = s < 10 ? "0" + s : s;
      return y + "-" + M + "-" + d + " " + h + ":" + m + ":" + s;
    }
  },
  computed: {
    getVal: function() {
      if (this.listData.length === 0) {
        this.listData = [
          {
            koulingName: "暂无口令",
            prize: JSON.stringify([{ from: 0, to: 0 }, { from: 0, to: 0 }]),
            endTime: 0
          }
        ];
      }
      return this.listData[0];
    }
	},
  mounted() {
		var that = this;
    if (!Array.prototype.filter) {
      Array.prototype.filter = function(fun) {
        "use strict";
        if (this === void 0 || this === null) throw new TypeError();
        var t = Object(this);
        var len = t.length >>> 0;
        if (typeof fun !== "function") throw new TypeError();
        var res = [];
        var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
        for (var i = 0; i < len; i++) {
          if (i in t) {
            var val = t[i];
            if (fun.call(thisArg, val, i, t)) res.push(val);
          }
        }
        return res;
      };
		}
		this.$http.post('/logic/kouling/selectKouling').then(res =>{
			var resFrom = res.data
			var listData = resFrom.filter(function(item1){
				return item1.koulingType.indexOf('WeChat') !== -1;
			}).filter(function(item){
				return Date.parse(new Date()) < item.endTime && Date.parse(new Date()) > item.startTime
			});
			that.$set(that, 'listData', listData);
		})
  }
};
</script>
<style lang="less" scoped>
.wechat-kouling {
  width: 100%;
  height: 5.91rem;
  background: url('~assets/images/kouling-background.svg');
  background-size: cover;
  position: relative;
  padding-top: 0.17rem;
}

.kouling-bg {
  background: url('~assets/images/kouling-koulingbg.svg');
  background-size: cover;
  font-size: 0.29rem;
  color: #333;
  text-align: center;
  width: 3.08rem;
  height: 0.867rem;
  line-height: 0.867rem;
  margin: 0 auto;
}

.kouling-bg > h2 {
  -webkit-user-select: auto;
}

.leftCircle, .rightCircle {
  width: 0.17rem;
  height: 0.17rem;
  border-radius: 50%;
  position: absolute;
  background: #FF8116;
  top: 1.7rem;
}

.leftCircle {
  left: 0.08rem;
}

.rightCircle {
  right: 0.08rem;
}

.wechat-kouling > div {
  width: 3.42rem;
  height: 5.57rem;
  background: #fff;
  margin: 0 auto;
  border-radius: 0.17rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.wechat-kouling > div > .title {
  width: 1.67rem;
  height: 0.16rem;
  margin: 0.26rem auto;
}

.wechat-kouling > div > .copy {
  width: 3.08rem;
  height: 0.12rem;
  margin-top: 0.19rem;
}

.wechat-kouling > div > .reward {
  width: 0.67rem;
  height: 0.17rem;
  margin-top: 0.36rem;
}

.rewardBox {
  margin: 0.17rem auto;
}

.rewardBox > .goldText, .rewardBox > .redText {
  width: 1.5rem;
  height: 0.99rem;
  text-align: center;
  background: #f8f8f8;
  font-size: 0.15rem;
  line-height: 0.21rem;
  display: inline-block;
  vertical-align: middle;
}
.rewardBox > .goldText{
	margin-right:0.03rem;
}
.rewardBox > .goldText > img, .rewardBox > .redText > img {
  width: 0.64rem;
  height: 0.64rem;
}

.rewardBox > .goldText > p,.rewardBox > .redText > p {
	margin-top: 0.03rem;
}

.rewardBox > .goldText {
  color: #ff9500;
}

.rewardBox > .redText {
  color: #ff5a36;
}

.wechat-kouling > div > button {
  width: 2.27rem;
  height: 0.65rem;
  background: url('~assets/images/kouling-button.svg');
  background-size: cover;
  border: 0;
  margin-top: 0.38rem;
}

#text1 {
  font-size: 0.15rem;
  line-height: 0.15rem;
  color: #666;
}

#text2 {
  font-size: 0.15rem;
  line-height: 0.15rem;
  color: #999;
  margin-top: 0.33rem;
  margin-bottom: 0.25rem;
}
</style>